import { api } from "@/api";
import { sleep } from "@/shared/utils";

export interface KudeResponse {
  success: boolean;
  data: {
    ventaId: string;
    numeroVenta: string;
    documentoElectronicoId: string;
    cdc: string;
    kudeBase64: string;
  };
}

export async function getVentaKude(ventaId: string): Promise<KudeResponse> {
  await sleep(1000);
  const response = await api.get<KudeResponse>(`ventas/${ventaId}/kude`);
  return response.data;
}
